import React from 'react';

import Icon from '../atom/Icon';

import ThemeStyle from '../../../lib/style/ThemeStyle';

const Evaluation = ({ star }) =>
  [1, 2, 3, 4, 5].map((num) => (
    <Icon
      key={num}
      iconName="favorite"
      style={{
        color:
          star >= num
            ? ThemeStyle.color.orangePink
            : ThemeStyle.color.pinkishGrey,
      }}
    />
  ));

export default Evaluation;
